









































import Vue from "vue";
import Avatar from "@/components/Avatar.vue";

interface State {
  sortedPlayers: any[];
  sortedFollowing: any[];
}
export default Vue.extend({
  name: "PlayerSelectors",
  components: { Avatar },
  props: {
    players: {
      type: Array,
      required: true
    },
    following: {
      type: Array,
      required: true
    }
  },
  data(): State {
    return {
      sortedPlayers: [],
      sortedFollowing: []
    };
  },
  mounted() {
    this.sortedPlayers = this.sortPlayers();
  },
  methods: {
    emitClick(): void {
      this.$emit("select", {});
    },
    concatTeams(player: { orgUnits: any[] }): string {
      //Only list the organization name if the player has no assigned teams in the organization
      if (player.orgUnits.length === 1) {
        return player.orgUnits[0].name;
      }

      let teams = player.orgUnits
        .filter((ou: any) => !ou.isOrganization && !ou.dateArchived)
        .map((ou: { name: string }) => ou.name);

      teams = teams.length > 0 ? teams : ["No teams assigned"];

      teams =
        teams.length > 3
          ? teams.slice(0, 3).concat(`and ${teams.length - 3} more...`)
          : teams;

      return teams.join(", ");
    },
    sortPlayers(): any {
      const alpha = this.players.sort((a: any, b: any) => {
        return a.name > b.name ? 1 : -1;
      });
      const noTeams = alpha.filter((p: any) => p.orgUnits.length === 0);
      const withTeams = alpha.filter((p: any) => p.orgUnits.length > 0);
      return withTeams.concat(noTeams);
    },
    sortFollowers(): any {
      const alpha = this.following.sort((a: any, b: any) => {
        return a.name > b.name ? 1 : -1;
      });
      const noTeams = alpha.filter((p: any) => p.orgUnits.length === 0);
      const withTeams = alpha.filter((p: any) => p.orgUnits.length > 0);
      return withTeams.concat(noTeams);
    }
  }
});
